import { HttpClient, HttpEvent } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { catchError, Observable, of } from 'rxjs';

import { EnvironmentConfig } from '../config/environment.config';

@Injectable({ providedIn: 'root' })
export class MediaService {
  constructor(
    @Inject('environment') public environment: EnvironmentConfig,
    private http: HttpClient
  ) {}

  getMediaUrl(mediaId: string): Observable<{ url: string }> {
    return this.http.get<{ url: string }>(`${this.environment.endPoint}media/${mediaId}`);
  }

  getMediaData(mediaId: string): Observable<Blob> {
    return this.http.get<Blob>(`${this.environment.endPoint}media/${mediaId}/data`, { responseType: 'blob' as 'json' });
  }

  uploadStimulus(media: FormData): Observable<HttpEvent<{ id: string }>> {
    return this.http
      .post<{ id: string }>(`${this.environment.endPoint}media`, media, { responseType: 'json', reportProgress: true, observe: 'events' })
      .pipe(catchError(() => of(null)));
  }

  uploadEmailMedia(media: FormData): Observable<{ url: string }> {
    return this.http.post<{ url: string }>(`${this.environment.endPoint}email-media`, media).pipe(catchError(() => of(null)));
  }

  deleteStimulus(mediaId: string): Observable<unknown> {
    return this.http.delete(`${this.environment.endPoint}media/${mediaId}`).pipe(catchError(() => of(null)));
  }

  downloadMediaZip(ids: string[], fileName: string): Observable<Blob> {
    return this.http
      .post<Blob>(`${this.environment.endPoint}media/download/zip`, { ids, fileName }, { responseType: 'blob' as 'json' })
      .pipe(catchError(() => of(null)));
  }
}
